<!--직종선택 팝업 -->
<template>
    <modal v-if="isModalShow">
        <template slot="header">
          <h4 class="modal-title">학과 조회</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closed">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <div class="md-layout">
            <table class="flex-table">
              <tr>
                <th class="w30">구분코드</th>
                <td>
                  <input type="text" :disabled="lCodeCd" v-model="lCodeCd">
                </td>
                <th class="w30">대학코드</th>
                <td>
                    <input type="text" disabled v-model="mCodeCd">
                </td>
                <th class="w30">학과</th>
                <td colspan="5">
                  <div class="inline-flex">
                    <input v-focus type="text" v-model="codeCd" v-on:keyup.enter="search">
                    <input v-focus type="text" v-model="searchText" v-on:keyup.enter="search">
                    <button @click="search">
                      <md-icon>search</md-icon>조회
                    </button>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <md-card-content>
            <div align="left">총 {{ total }} 건의 검색결과가 있습니다.</div>
            <grid ref="commcodeGrid"
                  :data="gridProps.data"
                  :columns="gridProps.columns"
                  :options="gridProps.options"
                  :theme="gridProps.theme"
                  :rowHeaders="gridProps.rowHeaders"
                  :columnOptions="gridProps.columnOptions"
                  :language="gridProps.lang"
                  @dblclick="onDblClickExecutive"
                  @response="successResponse"
            ></grid>
          </md-card-content>

        </template>
        <template slot="footer">
          <md-button class="md-default md-sm" @click="closed">닫기</md-button>
        </template>
      </modal>
</template>

<script>

import { Modal } from "@/components";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import URL_CONST from "@/kuaa/kuaa-url-const";

import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

export default {
  name: "ClassSearchPopComp",
  props: {
    isShow : {
      type: Boolean,
      default: false
    },
    lCodeCd : {
      type: String,
      default: null
    },
    mCodeCd : {
      type: String,
      default: null
    }
  },
  components: {
    Modal,
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
      isModalShow: function(){
          return this.isShow;
      }
  },
  data() {
    return {
      codeCd: "",
      searchText: "",
      total: 0,
      pagination: {
        perPage: 20,
        page: 1,
        total: 0
      }
    };
  },
  methods: {
    closed(){
        this.$emit('update:isShow', false);
    },

    search() {
      let param = {
        perPage: 20,
        level: 'S',
        codeGrpId: 'COLLEGE_CD',
        lCodeCd: this.mCodeCd.substring(0,1) == 'I'? null: this.lCodeCd,   // 통합단과대 적용
        mCodeCd: this.mCodeCd.substring(0,1) == 'I'? null: this.mCodeCd,   // 통합단과대 적용
        etcMeta5: this.mCodeCd.substring(0,1) == 'I'? this.mCodeCd: null,  // 통합단과대 적용
        codeCd: this.codeCd,
        codeNm: this.searchText
      };
      this.$refs.commcodeGrid.invoke("readData", 1, param);
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_COMMON_CODE_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.commcodeGrid;
      this.gridProps['columns'] = [
          {header: '대학코드', name: 'mCodeCd', sortable: true},
          {header: '대학명', name: 'mCodeNm', hidden:true},
          {header: '코드', name: 'code', width: "100", align:"center", sortable: true},
          {header: '학과', name: 'codeNm', sortable: true},
          {header: '학과명', name: 'path', width: "300", minWidth:200, sortable: true},
          {header: '캠퍼스코드', name: 'lCodeCd', hidden: true},
          {header: '캠퍼스명', name: 'lCodeNm', hidden: true},
          //{header: '대학코드', name: 'mCodeCd', hidden: true},
          //{header: '대학명', name: 'mCodeNm', hidden: true}
        ];
    },

    successResponse(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"학과 조회");
      }
    },

    onDblClickExecutive(e) {
      if(e.instance.getRow(e.rowKey) != null) {
        this.$emit('returnResult', e.instance.getRow(e.rowKey));
        this.closed();
      }
    }
  }
}
</script>

<style lang="css" scoped>

</style>